import { useTranslation } from 'react-i18next';

import { Headline, PageWrapper } from 'libs/ui';

export const Empty = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <Headline>
        <p>{t('errors.noComponents')}</p>
      </Headline>
    </PageWrapper>
  );
};
